import {
  Building2,
  Clapperboard,
  GraduationCap,
  Megaphone,
  Video,
} from 'lucide-react';

import { TwinneeLogo } from '@/components/TwinneeLogo';
/** Canonical audience use cases — icons, accents, and copy shared across the app. */
export const AUDIENCE_USE_CASES = [
  {
    id: 'content-creators',
    title: 'Content creators',
    body: 'Batch shorts, explainers, and serialized posts with consistent characters and a scene-native timeline.',
    Icon: Video,
    accent: '#a78bfa',
    gradient: 'from-violet-950/80 via-slate-900 to-black',
  },
  {
    id: 'movie-creators',
    title: 'Movie creators',
    body: 'Draft stories, generate shots per scene, and iterate with Director AI—without losing narrative structure.',
    Icon: Clapperboard,
    accent: '#f59e0b',
    gradient: 'from-amber-950/70 via-slate-900 to-black',
  },
  {
    id: 'influencers',
    title: 'Influencers',
    body: 'Spin up polished promo clips and story-driven ads that match your brand tone in minutes, not days.',
    Icon: TwinneeLogo,
    accent: '#fb7185',
    gradient: 'from-rose-950/60 via-slate-900 to-black',
  },
  {
    id: 'corporate-storytelling',
    title: 'Corporate storytelling',
    body: 'Product launches, internal comms, and brand films—script to screen with approvals-friendly scene cuts.',
    Icon: Building2,
    accent: '#38bdf8',
    gradient: 'from-sky-950/70 via-slate-900 to-black',
  },
  {
    id: 'trainers',
    title: 'Trainers',
    body: 'Build lesson modules as scenes—narration, on-screen text, and regen per beat for faster course updates.',
    Icon: GraduationCap,
    accent: '#34d399',
    gradient: 'from-emerald-950/70 via-slate-900 to-black',
  },
  {
    id: 'ad-agencies',
    title: 'Ad agencies',
    body: 'Pitch concepts with real motion, swap providers per shot, and ship client cuts from one workspace.',
    Icon: Megaphone,
    accent: '#fb923c',
    gradient: 'from-orange-950/70 via-slate-900 to-black',
  },
];

/** @deprecated Use AUDIENCE_USE_CASES — kept for existing imports */
export const landingAudienceUseCases = AUDIENCE_USE_CASES;

const byId = Object.fromEntries(AUDIENCE_USE_CASES.map((item) => [item.id, item]));

export function getAudienceUseCase(id) {
  return byId[id] || byId['content-creators'];
}

/** CPP partner segment cards → audience icon set */
export const PARTNER_SEGMENT_AUDIENCE_ID = {
  influencers: 'influencers',
  creators: 'content-creators',
  storytellers: 'movie-creators',
  'ai-moviemakers': 'movie-creators',
  'ad-makers': 'ad-agencies',
  podcasters: 'content-creators',
  'video-editors': 'movie-creators',
};

/** CPP application role values → audience icon set */
export const PARTNER_ROLE_AUDIENCE_ID = {
  influencer: 'influencers',
  creator: 'content-creators',
  storyteller: 'movie-creators',
  ai_moviemaker: 'movie-creators',
  ad_maker: 'ad-agencies',
  podcaster: 'content-creators',
  video_editor: 'movie-creators',
};

export function audienceIdForPartnerSegment(segmentId) {
  return PARTNER_SEGMENT_AUDIENCE_ID[segmentId] || 'content-creators';
}

export function audienceIdForPartnerRole(roleValue) {
  return PARTNER_ROLE_AUDIENCE_ID[roleValue] || 'content-creators';
}
